// @flow

import { combineReducers } from 'redux-immutable';

import lista from './lista';
import filtro from './filtro';

export default combineReducers({ lista, filtro });